import React from "react";
import "react-slidedown/lib/slidedown.css";
import { Col, Row } from "react-bootstrap";
import { SlideDown } from "react-slidedown";
import {
  GeneralFillSurvey,
  FillSurveyBackground,
  FillSurveyContentQuestions,
  GeneralStyleFS,
  LowerWrapperFS,
  StyledButtonFS,
  ContainerIterationQuestionlikeFS,
  ContainerIterationYesOrNotFS,
  SizeFaceFS,
  OptionsSectionFS,
  OptionWrapperFS,
  SizeImgRatingFS,
  GeneralFillSurveyHead,
  IsmandatoryFS,
  ValidationTextStyleFS,
  FillSurveyContentInternal,
  ContainerLogoFS,
  ShowImageContainerFS,
  OptionWrapperOtherFS,
  FillSurveyContentTextBanner,
  FillSurveySmileyFace,
  DropdownOptionWrapperFS,
  InputNumberContainer,
} from "./FillOutSurvey.styled";
//FACE 5
import SentimentVerySatisfiedTwoToneIcon from "@material-ui/icons/SentimentVerySatisfiedTwoTone";
//FACE 4
import EmojiEmotionsTwoToneIcon from "@material-ui/icons/EmojiEmotionsTwoTone";
//FACE 3
import SentimentSatisfiedTwoToneIcon from "@material-ui/icons/SentimentSatisfiedTwoTone";
//FACE 2
import MoodBadTwoToneIcon from "@material-ui/icons/MoodBadTwoTone";
//FACE 1
import SentimentVeryDissatisfiedTwoToneIcon from "@material-ui/icons/SentimentVeryDissatisfiedTwoTone";
import DateCalendarComponent from "../DateCalendarComponent/DateCalendarComponent";
import { Box, TextField } from "@material-ui/core";
import TooltipComponent from "../TooltipComponent";
import CustomInputFileComponent from "../CustomInputFileComponent/CustomInputFileComponent";
import LocationAnswerComponent from "../LocationAnswerComponent/LocationAnswerComponent";
import ImageComponent from "../ImageComponent";
import RadioButtonComponent from "../RadioButtonComponent";
import RadioButtonLikeComponent from "../RadioButtonLikeComponent";
import PropTypes from "prop-types";

const FillOutSurvey = ({
  surveyData,
  surveyQuestionData,
  handleSaveSurvey,
  titleConfiguration,
  footerConfiguration,
  buttonSaveConfiguration,
  backgroundConfiguration,
  questionsConfiguration,
  answerConfiguration,
  mandatoryMissing,
  imgBackground,
  banners,
  logoSurvey,
  logoConfiguration,
  QuestionsSave,
  setQuestionsSave,
  imagesChoice,
  activeBtnSaveConfigPreview,
  answersDependent,
  setAnswersDependent,
}) => {
  const initalColor = "white";
  const showMandatory = (question) => {
    const exists = mandatoryMissing.findIndex((M) => M === question.idQuestion);

    return (
      exists !== -1 &&
      question.isMandatory &&
      question.idQuestionNavigation.validationText && (
        <ValidationTextStyleFS>
          {question.idQuestionNavigation.validationText}
        </ValidationTextStyleFS>
      )
    );
  };

  const orderArraySaveData = (data) => {
    const position = QuestionsSave.findIndex((x) => x.idQuestion === data.idQuestion);
    if (position !== -1) {
      const updatedQuestionsSave = [...QuestionsSave];
      updatedQuestionsSave[position] = data;
      setQuestionsSave(updatedQuestionsSave);
    } else {
      setQuestionsSave([...QuestionsSave, data]);
    }
  };

  const setQualification = ({
    elementKey,
    selectImage,
    idQuestion,
    internalCode,
    typeQuestion,
  }) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: selectImage,
      answerClient: elementKey,
      active: true,
      createUser: "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationSmile = (
    e,
    value,
    lbtext,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    const titleAnswer = lbtext || value;
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: `${titleAnswer}`,
      answerClient: value,
      active: true,
      createUser: "",
      typeQuestion,
    });
  };
  const setQualificationOpenText = (
    e,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    e.preventDefault();
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: null,
      answerClient: e.target.value,
      active: true,
      createUser: "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationDropdownSingleSelect = (
    e,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: null,
      answerClient: e.target.value,
      active: true,
      createUser: "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationYesNoAndLike = (
    elementValue,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: null,
      answerClient: elementValue,
      active: true,
      createUser: "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationMultipleChoice = (
    nameL1_BRAN,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    const positionQuestionsSave = QuestionsSave.findIndex(
      (x) => x.idQuestion === idQuestion
    );
    let choiceSelected = nameL1_BRAN;
    if (positionQuestionsSave !== -1) {
      choiceSelected = QuestionsSave[positionQuestionsSave].answerClient;
      const choiceSelectedArray = choiceSelected.split("|");
      const position = choiceSelectedArray.findIndex((x) => x === nameL1_BRAN);

      position === -1
        ? choiceSelectedArray.push(nameL1_BRAN)
        : choiceSelectedArray.splice(position, 1);
      
      choiceSelected = choiceSelectedArray.join("|");
    }
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: null,
      answerClient: choiceSelected.startsWith("|")
        ? choiceSelected.substr(1)
        : choiceSelected,
      active: true,
      createUser: "",
      typeQuestion,
    });
  };  
  const setQualificationMultipleChoiceSingle = (
    child,
    idQuestion,
    internalCode,
    typeQuestion,
    questionProps
  ) => {
    const position = answersDependent.findIndex(
      (f) => f.idQuestionSurvey === questionProps.idQuestionSurvey
    );
  
    if (position > -1) {
      const filteredQuestions = surveyQuestionData.filter(
        (f) =>
          f.dependentAnswer === answersDependent[position].answer &&
          f.idParentQuestion === answersDependent[position].idQuestionSurvey
      );
  
      filteredQuestions.forEach((m) => {
        const positionDelete = QuestionsSave.findIndex(
          (i) => i.idQuestion === m.idQuestion
        );
        if (positionDelete > -1) QuestionsSave.splice(positionDelete, 1);
      });
  
      setQuestionsSave([...QuestionsSave]);
  
      answersDependent[position].answer =
        typeQuestion === "MultipleChoiceImageSingleSelect"
          ? child.replace("|", "-")
          : child;
    } else {
      const updatedAnswersDependent = {
        idQuestionSurvey: questionProps.idQuestionSurvey,
        answer:
          typeQuestion === "MultipleChoiceImageSingleSelect"
            ? child.replace("|", "-")
            : child,
      };
      setAnswersDependent([updatedAnswersDependent]);
  
      orderArraySaveData({
        idAnswerClient: 0,
        code: null,
        idQuestion,
        idSurvey: surveyData.idSurvey,
        titleAnswer: null,
        answerClient: child,
        active: true,
        createUser: "",
        typeQuestion,
      });
    }
  };
  const setQualificationDateOption = (
    elementValue,
    idQuestion,
    typeQuestion
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: null,
      answerClient: elementValue,
      active: true,
      createUser: "",
      typeQuestion: typeQuestion,
    });
  };

  const setQualificationAttachFile = async (
    elementValue,
    idQuestion,
    internalCode,
    typeQuestion,
    file
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: null,
      answerClient: elementValue,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
      file: file,
    });
  };

  const setQualificationLocation = async (
    elementValue,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: surveyData.idSurvey,
      titleAnswer: null,
      answerClient: elementValue,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };

  const answersType = (
    jsonConfiguration,
    idQuestion,
    tpsurveyAnswerQuestionSurveys,
    questionProps
  ) => {
    const NUMERIC_REGEX = /^[0-9-]+$/;
    let configuration = JSON.parse(jsonConfiguration);
    let numericField = configuration.numericField;

    switch (configuration.typeQuestion) {
      case "OpenText":
        return numericField ? (
          <InputNumberContainer>
            <TextField
              style={{ paddingTop: "0.5em" }}
              fullWidth
              variant="outlined"
              helperText="Only numeric values are allowed"
              type="number"
              size="small"
              onKeyDown={(event) => {
                if (event.key !== "Backspace" && !event.key.includes("Arrow")) {
                  if (!NUMERIC_REGEX.test(event.key)) {
                    event.preventDefault();
                  }
                }
              }}
              onBlur={(e) =>
                setQualificationOpenText(
                  e,
                  idQuestion,
                  tpsurveyAnswerQuestionSurveys,
                  configuration.typeQuestion
                )
              }
            ></TextField>
          </InputNumberContainer>
        ) : (
          <textarea
            onBlur={(e) =>
              setQualificationOpenText(
                e,
                idQuestion,
                tpsurveyAnswerQuestionSurveys,
                configuration.typeQuestion
              )
            }
          ></textarea>
        );
      case "ImageRating":
        let dataStars = [];
        let colorImageRating = "";
        let actualQuestion = QuestionsSave.filter((x) => {
          return x.idQuestion === idQuestion;
        });
        for (let i = 1; i <= JSON.parse(configuration.cantElements); i++) {
          colorImageRating = configuration.colorPicker;
          let f = {
            key: i,
            elementKey: i,
            colorPicker:
              actualQuestion.length && actualQuestion[0].answerClient >= i
                ? configuration.colorPicker
                : initalColor,
            setQualification: setQualification,
            selectImage: configuration.nameShape,
          };
          dataStars.push(f);
        }
        let arrayImageRating = [];

        dataStars.length > 0 &&
          dataStars.forEach((data) => {
            arrayImageRating = [
              ...arrayImageRating,
              <ImageComponent
                key={data.key}
                elementKey={data.elementKey}
                idQuestion={idQuestion}
                colorPicker={data.colorPicker}
                setQualification={data.setQualification}
                selectImage={data.selectImage}
                internalCode={tpsurveyAnswerQuestionSurveys}
                typeQuestion={configuration.typeQuestion}
              />,
            ];
          });
        return (
          <SizeImgRatingFS
            backgroundColor={configuration?.background}
            color={colorImageRating}
          >
            {arrayImageRating.reverse()}
          </SizeImgRatingFS>
        );
      case "QuestionYesNo":
        let dataYesOrNot = [];
        configuration.questionSettings.forEach((qYoN) => {
          dataYesOrNot = [
            ...dataYesOrNot,
            <RadioButtonComponent
              key={qYoN.id}
              elementKey={qYoN.id}
              elementValue={qYoN.value}
              setAnswerQuestion={setQualificationYesNoAndLike}
              idQuestion={idQuestion}
              internalCode={tpsurveyAnswerQuestionSurveys}
              typeQuestion={configuration.typeQuestion}
              configuration={configuration}
              answerConfiguration={answerConfiguration}
              question={questionProps}
              answersDependent={answersDependent}
              setAnswersDependent={setAnswersDependent}
              surveyQuestionData={surveyQuestionData}
              QuestionsSave={QuestionsSave}
              setQuestionsSave={setQuestionsSave}
            />,
          ];
        });
        return (
          <ContainerIterationYesOrNotFS>
            {dataYesOrNot}
          </ContainerIterationYesOrNotFS>
        );
      case "QuestionLike":
        let dataLike = [];
        configuration.questionSettings.forEach((ql) => {
          dataLike = [
            ...dataLike,
            <RadioButtonLikeComponent
              key={ql.id}
              elementKey={ql.id}
              elementValue={ql.value}
              setAnswerQuestionLike={setQualificationYesNoAndLike}
              idQuestion={idQuestion}
              internalCode={tpsurveyAnswerQuestionSurveys}
              typeQuestion={configuration.typeQuestion}
              configuration={configuration}
              answerConfiguration={answerConfiguration}
            />,
          ];
        });
        return (
          <ContainerIterationQuestionlikeFS
            backgroundColor={configuration?.background}
          >
            {dataLike}
          </ContainerIterationQuestionlikeFS>
        );
      case "SmileyFaces":
        let dataSmile = [];
        let actualQuestionSmile = QuestionsSave.filter((x) => {
          return x.idQuestion === idQuestion;
        });
        configuration.caritas
          .sort((x, y) => {
            return parseInt(y.value) - parseInt(x.value);
          })
          .forEach((f, index) => {
            switch (parseInt(f.face)) {
              case 5:
                dataSmile = [
                  <SizeFaceFS key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <SentimentVeryDissatisfiedTwoToneIcon
                      onClick={(e) =>
                        setQualificationSmile(
                          e,
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                            actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFaceFS>,
                  ...dataSmile,
                ];
                break;
              case 4:
                dataSmile = [
                  <SizeFaceFS key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <MoodBadTwoToneIcon
                      onClick={(e) =>
                        setQualificationSmile(
                          e,
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                            actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFaceFS>,
                  ...dataSmile,
                ];
                break;
              case 3:
                dataSmile = [
                  <SizeFaceFS key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <SentimentSatisfiedTwoToneIcon
                      onClick={(e) =>
                        setQualificationSmile(
                          e,
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                            actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFaceFS>,
                  ...dataSmile,
                ];
                break;
              case 2:
                dataSmile = [
                  <SizeFaceFS key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <EmojiEmotionsTwoToneIcon
                      onClick={(e) =>
                        setQualificationSmile(
                          e,
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                            actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFaceFS>,
                  ...dataSmile,
                ];
                break;
              case 1:
                dataSmile = [
                  <SizeFaceFS key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <SentimentVerySatisfiedTwoToneIcon
                      onClick={(e) =>
                        setQualificationSmile(
                          e,
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                            actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFaceFS>,
                  ...dataSmile,
                ];
                break;
              default:
                dataSmile = [...dataSmile];
                break;
            }
          });

        return (
          <FillSurveySmileyFace backgroundColor={configuration?.background}>
            {dataSmile}
          </FillSurveySmileyFace>
        );

      case "MultipleChoiceMultiSelect":
        return (
          <OptionsSectionFS>
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                .filter((i) => i !== "Other")
                .map((child) => {
                  return (
                    <OptionWrapperFS key={child} editable={true}>
                      <input
                        type="checkbox"
                        onClick={() =>
                          setQualificationMultipleChoice(
                            child,
                            idQuestion,
                            tpsurveyAnswerQuestionSurveys,
                            configuration.typeQuestion
                          )
                        }
                        defaultValue={child}
                      />{" "}
                      <label
                        style={
                          configuration.customStyle
                            ? configuration.answer
                            : answerConfiguration
                        }
                      >
                        {child}
                      </label>
                    </OptionWrapperFS>
                  );
                })
              : null}
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                .filter((i) => i === "Other")
                .map((child) => {
                  let position = QuestionsSave.findIndex(
                    (f) => f.idQuestion === idQuestion
                  );
                  let showText = QuestionsSave[
                    position
                  ]?.answerClient.includes("Other")
                    ? true
                    : false;
                  return (
                    <OptionWrapperOtherFS key={child} editable={true}>
                      <input
                        type="checkbox"
                        defaultValue={child}
                        onClick={() =>
                          setQualificationMultipleChoice(
                            child,
                            idQuestion,
                            tpsurveyAnswerQuestionSurveys,
                            configuration.typeQuestion
                          )
                        }
                      />{" "}
                      <label
                        style={
                          configuration.customStyle
                            ? configuration.answer
                            : answerConfiguration
                        }
                      >
                        {child}
                      </label>
                      {showText && (
                        <input
                          type="text"
                          id={`MultipleChoiceMultiSelectOther-${child}`}
                          name={`MultipleChoiceMultiSelectOther-${idQuestion}`}
                          onBlur={(e) =>
                            setQualificationMultipleChoice(
                              child + ":" + e.target.value,
                              idQuestion,
                              tpsurveyAnswerQuestionSurveys,
                              configuration.typeQuestion
                            )
                          }
                        />
                      )}
                    </OptionWrapperOtherFS>
                  );
                })
              : null}
          </OptionsSectionFS>
        );
      case "MultipleChoiceSingleSelect":
        return (
          <OptionsSectionFS>
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                .filter((i) => i !== "Other")
                .map((child) => {
                  return (
                    <OptionWrapperFS key={child} editable={true}>
                      <input
                        type="radio"
                        id={`MultipleChoiceSingleSelect-${child}`}
                        name={`MultipleChoiceSingleSelect-${idQuestion}`}
                        onClick={() =>
                          setQualificationMultipleChoiceSingle(
                            child,
                            idQuestion,
                            tpsurveyAnswerQuestionSurveys,
                            configuration.typeQuestion,
                            questionProps
                          )
                        }
                        defaultValue={child}
                      />{" "}
                      <label
                        style={
                          configuration.customStyle
                            ? configuration.answer
                            : answerConfiguration
                        }
                      >
                        {child}
                      </label>
                    </OptionWrapperFS>
                  );
                })
              : null}
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                .filter((i) => i === "Other")
                .map((child) => {
                  let position = QuestionsSave.findIndex(
                    (f) => f.idQuestion === idQuestion
                  );
                  let showText = QuestionsSave[
                    position
                  ]?.answerClient.includes("Other")
                    ? true
                    : false;
                  return (
                    <OptionWrapperOtherFS key={child} editable={true}>
                      <input
                        type="radio"
                        id={`MultipleChoiceSingleSelect-${child}`}
                        name={`MultipleChoiceSingleSelect-${idQuestion}`}
                        defaultValue={child}
                        onClick={() =>
                          setQualificationMultipleChoiceSingle(
                            child,
                            idQuestion,
                            tpsurveyAnswerQuestionSurveys,
                            configuration.typeQuestion,
                            questionProps
                          )
                        }
                      />{" "}
                      <label
                        style={
                          configuration.customStyle
                            ? configuration.answer
                            : answerConfiguration
                        }
                      >
                        {child}
                      </label>
                      {showText && (
                        <input
                          type="text"
                          id={`MultipleChoiceSingleSelectOther-${child}`}
                          name={`MultipleChoiceSingleSelectOther-${idQuestion}`}
                          onBlur={(e) =>
                            setQualificationMultipleChoiceSingle(
                              child + ":" + e.target.value,
                              idQuestion,
                              tpsurveyAnswerQuestionSurveys,
                              configuration.typeQuestion,
                              questionProps
                            )
                          }
                        />
                      )}
                    </OptionWrapperOtherFS>
                  );
                })
              : null}
          </OptionsSectionFS>
        );
      case "MultipleChoiceImageSingleSelect":
        return (
          <OptionsSectionFS>
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList.map((child, i) => {
                return (
                  <div key={i}>
                    <OptionWrapperFS key={child.text} editable={true}>
                      <input
                        type="radio"
                        id={`MultipleChoiceImageSingleSelect-${child.text}`}
                        name={`MultipleChoiceImageSingleSelect-${idQuestion}`}
                        onClick={() =>
                          setQualificationMultipleChoiceSingle(
                            child.text + "|" + child.image,
                            idQuestion,
                            tpsurveyAnswerQuestionSurveys,
                            configuration.typeQuestion,
                            questionProps
                          )
                        }
                        defaultValue={child.text}
                      />{" "}
                      <label
                        style={
                          configuration.customStyle
                            ? configuration.answer
                            : answerConfiguration
                        }
                      >
                        {child.text}
                      </label>
                    </OptionWrapperFS>

                    <ShowImageContainerFS
                      src={
                        imagesChoice.filter(
                          (i) => i.nameImage === child.image
                        )[0]?.url
                      }
                    ></ShowImageContainerFS>
                  </div>
                );
              })
              : null}
          </OptionsSectionFS>
        );
      case "DropdownSingleSelect":
        return (
          <OptionsSectionFS>
            <DropdownOptionWrapperFS
              key={`OptionWrapper-DropdownSingleSelect-${idQuestion}`}
              editable={true}
            >
              <select
                id={`DropdownSingleSelect-${idQuestion}`}
                onChange={(e) =>
                  setQualificationDropdownSingleSelect(
                    e,
                    idQuestion,
                    tpsurveyAnswerQuestionSurveys,
                    configuration.typeQuestion
                  )
                }
              >
                <option value="" disabled selected>
                  - Select an option -
                </option>
                {configuration && configuration.answerList.length > 0
                  ? configuration.answerList.map((child) => {
                    return (
                      <option key={child} value={child}>
                        {child}
                      </option>
                    );
                  })
                  : null}
              </select>
            </DropdownOptionWrapperFS>
          </OptionsSectionFS>
        );
      case "Date":
        return (
          <OptionsSectionFS>
            <Col
              md={12}
              className={"my-3"}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Row style={{ width: "50%" }}>
                <Col md="12">
                  <DateCalendarComponent
                    keyId={`DateOption-${idQuestion}`}
                    componentConfiguration={configuration}
                    setQualificationDateOption={setQualificationDateOption}
                    idQuestion={idQuestion}
                    typeQuestion={configuration.typeQuestion}
                  />
                </Col>
              </Row>
            </Col>
          </OptionsSectionFS>
        );
      case "File":
        return (
          <OptionsSectionFS style={{ padding: "0px", paddingTop: "0.5em" }}>
            <CustomInputFileComponent
              keyId={`DateOption-${idQuestion}`}
              componentConfiguration={configuration}
              setQualificationAttachFile={setQualificationAttachFile}
              idQuestion={idQuestion}
              typeQuestion={configuration.typeQuestion}
            ></CustomInputFileComponent>
          </OptionsSectionFS>
        );
      case "Location":
        return (
          <OptionsSectionFS style={{ padding: "0px", paddingTop: "0.5em" }}>
            <LocationAnswerComponent
              keyId={`Location-${idQuestion}`}
              componentConfiguration={configuration}
              setQualificationLocation={setQualificationLocation}
              idQuestion={idQuestion}
              typeQuestion={configuration.typeQuestion}
            ></LocationAnswerComponent>
          </OptionsSectionFS>
        );

      default:
        return null;
    }
  };

  const fnShowQuestion = (q) => {
    return (
      !q.isDependent ||
      (q.isDependent &&
        answersDependent.findIndex(
          (f) =>
            f.idQuestionSurvey === q.idParentQuestion &&
            f.answer === q.dependentAnswer
        ) > -1)
    );
  };

  const renderShowSlideDown = () => {
    return surveyQuestionData && surveyQuestionData
      .slice()
      .sort((s, n) => parseInt(s.order) - parseInt(n.order))
      .map((q, index) => {
        let question = JSON.parse(q.jsonConfiguration);
        let objImg = banners?.find((x) => x.question === q.idQuestion);
        let componentToRender = null;
        if (question.typeQuestion === "InfoBanner") {
          componentToRender = (
            <GeneralFillSurveyHead key={q.idQuestion}>
              <img src={objImg?.url || ""} alt="" />
              <div
                className="redirection"
                style={{
                  backgroundColor: question.customStyle
                    ? question.background
                    : null,
                }}
              >
                <div
                  style={
                    question.customStyle
                      ? question.question
                      : questionsConfiguration
                  }
                >
                  <FillSurveyContentTextBanner
                    dangerouslySetInnerHTML={{
                      __html: q.idQuestionNavigation.nameQuestion,
                    }}
                  ></FillSurveyContentTextBanner>
                </div>
              </div>
            </GeneralFillSurveyHead>
          );
        } else {
          componentToRender = (
            <GeneralStyleFS
              color={question.customStyle ? question.background : null}
              key={q.idQuestion}
            >
              <LowerWrapperFS>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <div style={{ display: "flex" }}>
                    {q.isMandatory && <IsmandatoryFS>*</IsmandatoryFS>}
                    <h2
                      style={
                        question.customStyle
                          ? question.question
                          : questionsConfiguration
                      }
                    >
                      {q.idQuestionNavigation.nameQuestion}
                    </h2>
                  </div>
                  {question.tooltip?.status &&
                    question.tooltip?.descriptionText !== "" && (
                      <TooltipComponent
                        keyId={q.idQuestion}
                        descriptionText={
                          question.tooltip.descriptionText
                        }
                      ></TooltipComponent>
                    )}
                </Box>
                {answersType(
                  q.jsonConfiguration,
                  q.idQuestion,
                  q.tpsurveyAnswerQuestionSurveys,
                  q
                )}
                {showMandatory(q)}
              </LowerWrapperFS>
            </GeneralStyleFS>
          );
        }
        return (
          <SlideDown key={index} className={"my-dropdown-slidedown"}>
            {fnShowQuestion(q) && componentToRender}
          </SlideDown>
        );
      });
  };  
  
  return (
    <GeneralFillSurvey>
      <FillSurveyBackground
        backgroundColor={
          backgroundConfiguration && backgroundConfiguration.color
        }
        image={imgBackground}
      >
        <FillSurveyContentQuestions>
          <FillSurveyContentInternal>
            {logoSurvey !== "send" ? (
              <ContainerLogoFS
                positionLogo={logoConfiguration && logoConfiguration.position}
              >
                <img
                  style={logoConfiguration && logoConfiguration.sizeImage}
                  src={logoSurvey}
                  alt=""
                />
              </ContainerLogoFS>
            ) : null}

            {titleConfiguration && (
              <div
                dangerouslySetInnerHTML={{
                  __html: titleConfiguration.text,
                }}
              ></div>
            )}

            {renderShowSlideDown()}

            <div style={{ textAlign: "center" }}>
              {buttonSaveConfiguration && (
                <StyledButtonFS
                  onClick={
                    activeBtnSaveConfigPreview === "true"
                      ? handleSaveSurvey
                      : null
                  }
                  color={
                    buttonSaveConfiguration.color
                      ? buttonSaveConfiguration.color
                      : "#ffffff"
                  }
                  textDecoration={buttonSaveConfiguration.textDecoration}
                  fontStyle={buttonSaveConfiguration.fontStyle}
                  fontWeight={buttonSaveConfiguration.fontWeight}
                  fontFamily={buttonSaveConfiguration.fontFamily}
                  fontSize={buttonSaveConfiguration.fontSize}
                  align={buttonSaveConfiguration.align}
                  backgraundColor={buttonSaveConfiguration.backgroundColor}
                  image={buttonSaveConfiguration.image}
                  visibility={buttonSaveConfiguration.visibility}
                >
                  {buttonSaveConfiguration?.text
                    ? `${buttonSaveConfiguration.text}`
                    : `Send`}
                </StyledButtonFS>
              )}
              {footerConfiguration && (
                <div
                  style={{ margin: "20px 0" }}
                  dangerouslySetInnerHTML={{
                    __html: footerConfiguration.text,
                  }}
                ></div>
              )}
            </div>
          </FillSurveyContentInternal>
        </FillSurveyContentQuestions>
      </FillSurveyBackground>
    </GeneralFillSurvey>
  );
};

export default FillOutSurvey;

FillOutSurvey.propTypes = {
  surveyData: PropTypes.object,
  surveyQuestionData: PropTypes.object,
  handleSaveSurvey: PropTypes.func,
  titleConfiguration: PropTypes.object,
  footerConfiguration: PropTypes.object,
  buttonSaveConfiguration: PropTypes.object,
  backgroundConfiguration: PropTypes.object,
  questionsConfiguration: PropTypes.object,
  answerConfiguration: PropTypes.object,
  mandatoryMissing: PropTypes.array,
  imgBackground: PropTypes.string,
  banners: PropTypes.array,
  logoSurvey: PropTypes.string,
  logoConfiguration: PropTypes.object,
  QuestionsSave: PropTypes.array,
  setQuestionsSave: PropTypes.func,
  imagesChoice: PropTypes.array,
  activeBtnSaveConfigPreview: PropTypes.string,
  answersDependent: PropTypes.array.isRequired,
  setAnswersDependent: PropTypes.func,
}